import Vue from 'vue'
import { URL_ORGANIZATIONS } from '@/constants/urls.js'
import { BANK_ACCOUNTS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [BANK_ACCOUNTS_MANAGEMENT.STATE.BANK_ACCOUNTS]: null,
  [BANK_ACCOUNTS_MANAGEMENT.STATE.CURRENT_BANK_ACCOUNT]: null
}

const actions = {
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.GET_BANK_ACCOUNTS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/bankAccounts?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.GET_BANK_ACCOUNTS_LIST, resp.data)
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.GET_BANK_ACCOUNT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/bankAccounts/${model.accountType}/${model.bankAccountId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.GET_BANK_ACCOUNT, resp.data)
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.UPDATE_BANK_ACCOUNT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/bankAccounts/${model.accountType}/${model.bankAccountId}`,
      model: model.bankAccount
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.CHANGE_BANK_ACCOUNT_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/bankAccounts/${model.bankAccountId}/status`,
      model: {
        isActive: model.isActive
      }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.CREATE_BANK_ACCOUNT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/bankAccounts/${model.accountType}`,
      model: model.bankAccount
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.CLEAR_BANK_ACCOUNTS_LIST] ({ commit }) {
    commit(BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.CLEAR_BANK_ACCOUNTS_LIST)
  },
  async [BANK_ACCOUNTS_MANAGEMENT.ACTIONS.CLEAR_BANK_ACCOUNT] ({ commit }) {
    commit(BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.CLEAR_BANK_ACCOUNT)
  }
}

const mutations = {
  [BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.GET_BANK_ACCOUNTS_LIST] (state, bankAccounts) {
    state[BANK_ACCOUNTS_MANAGEMENT.STATE.BANK_ACCOUNTS] = bankAccounts
  },
  [BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.GET_BANK_ACCOUNT] (state, currentBankAccount) {
    state[BANK_ACCOUNTS_MANAGEMENT.STATE.CURRENT_BANK_ACCOUNT] = currentBankAccount
  },
  [BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.CLEAR_BANK_ACCOUNTS_LIST] (state) {
    state[BANK_ACCOUNTS_MANAGEMENT.STATE.BANK_ACCOUNTS] = null
  },
  [BANK_ACCOUNTS_MANAGEMENT.MUTATIONS.CLEAR_BANK_ACCOUNT] (state) {
    state[BANK_ACCOUNTS_MANAGEMENT.STATE.CURRENT_BANK_ACCOUNT] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
